'use client';

import { c as _c } from "react/compiler-runtime";
import { MobileNav } from '@/components/Header/MobileNav';
import { NavTitle } from '@/components/Header/NavTitle';
import { useHeaderContext } from '@/components/Header/provider';
import { arrangeNavLinks, parseLink, structureHeaderLinkGroups } from '@/components/Header/utils';
import { TdsNextLink, type TdsNextLinkProps } from '@/components/Link/TdsLink';
import RichText from '@/components/RichText';
import { SearchForm } from '@/components/Search';
import { DASHBOARD_PATH, NAV_CONTENT_ID, SKIP_TO_CONTENT_ID } from '@/constants';
import { useMatchMedia } from '@/hooks';
import { isMedia } from '@/payload/lib/isMedia';
import { type Header } from '@/types';
import { BurgerIcon } from '@tallinn-arvudes/ui/atoms/icons/burger-icon';
import { SearchIcon } from '@tallinn-arvudes/ui/atoms/icons/search-icon';
import { NavigationMenu, NavigationMenuContent, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuTrigger } from '@tallinn-arvudes/ui/atoms/navigation-menu';
import { useTrackOverflow } from '@tallinn-arvudes/ui/hooks';
import { Button } from '@tallinn-arvudes/ui/tallinn-design/Button';
import { cn } from '@tallinn-arvudes/ui/utils';
import Image from 'next/image';
import NextLink from 'next/link';
import { type ReactElement, Suspense, useEffect, useRef, useState } from 'react';
export const Navbar = t0 => {
  const $ = _c(59);
  const {
    headerData: data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["sm"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    isSmOnly
  } = useMatchMedia(t1);
  const {
    value,
    onValueChange
  } = useHeaderContext();
  const [isNavActive, setNavActive] = useState(false);
  const navMeasureRef = useRef(null);
  const {
    isOverflowing,
    initialized
  } = useTrackOverflow(navMeasureRef);
  const structuredHeader = structureHeaderLinkGroups(data);
  const arrangedNavLinks = arrangeNavLinks(structuredHeader.navLinks);
  let t2;
  if ($[1] !== onValueChange) {
    t2 = open => {
      if (!open) {
        onValueChange("");
      }
      setNavActive(open);
    };
    $[1] = onValueChange;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleNav = t2;
  let t3;
  let t4;
  if ($[3] !== isOverflowing || $[4] !== isSmOnly || $[5] !== value) {
    t3 = () => {
      if ((isSmOnly || isOverflowing) && value) {
        setNavActive(true);
      }
    };
    t4 = [isSmOnly, value, isOverflowing];
    $[3] = isOverflowing;
    $[4] = isSmOnly;
    $[5] = value;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  const T0 = NavigationMenu;
  const t5 = "bg-semantic-surface-brand block fixed";
  const t6 = "max-w-content w-full justify-self-center";
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <NextLink className="tds-link tds-link--inline fixed left-2 top-2 opacity-0 focus:opacity-100 focus:z-10" href={`#${SKIP_TO_CONTENT_ID}`} scroll={false}>Liigu sisu juurde</NextLink>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = NAV_CONTENT_ID;
  const t9 = "flex w-full h-[3.28rem] md:h-[4.7rem] px-4 md:px-6 items-center";
  let t10;
  if ($[9] !== data) {
    t10 = <div className="mr-8"><NavTitle data={data} /></div>;
    $[9] = data;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const t11 = "flex flex-1 flex-row static md:relative items-center left-0 right-0 top-0 bottom-0 md:gap-4";
  const t12 = "nav-list-container flex-1 flex w-0 relative overflow-hidden";
  const T1 = NavigationMenuList;
  const t13 = !initialized || isSmOnly;
  let t14;
  if ($[11] !== initialized || $[12] !== isOverflowing || $[13] !== isSmOnly || $[14] !== t13) {
    t14 = cn("transition-opacity duration-300 flex justify-evenly opacity-1", "data-[closed]:opacity-0", {
      invisible: t13
    }, {
      "opacity-0": !initialized || isOverflowing || isSmOnly
    });
    $[11] = initialized;
    $[12] = isOverflowing;
    $[13] = isSmOnly;
    $[14] = t13;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  const t15 = !isOverflowing && arrangedNavLinks?.map(_temp2);
  let t16;
  if ($[16] !== T1 || $[17] !== t14 || $[18] !== t15) {
    t16 = <div ref={navMeasureRef} className={t12}><T1 className={t14}>{t15}</T1></div>;
    $[16] = T1;
    $[17] = t14;
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  const t17 = !isOverflowing;
  let t18;
  if ($[20] !== t17) {
    t18 = cn("tds-button tds-button--secondary border-neutral-0 text-neutral-0 invisible", {
      "md:visible": t17
    });
    $[20] = t17;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  const t19 = data.dashboardLinkTitle || "Minu t\xF6\xF6laud";
  let t20;
  if ($[22] !== t18 || $[23] !== t19) {
    t20 = <div className="justify-end hidden md:flex"><NextLink prefetch={true} href={DASHBOARD_PATH} className={t18}>{t19}</NextLink></div>;
    $[22] = t18;
    $[23] = t19;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  let t21;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Button variant="icon" aria-label="Ava otsing" className="z-10 ml-auto text-white transition motion-reduce:transition-none opacity-100"><SearchIcon /></Button>;
    $[25] = t21;
  } else {
    t21 = $[25];
  }
  const t22 = !!data?.navLinks?.length ? "mr-1 md:-mr-3" : undefined;
  let t23;
  if ($[26] !== t22) {
    t23 = <Suspense fallback={t21}><SearchForm buttonClassName={t22} /></Suspense>;
    $[26] = t22;
    $[27] = t23;
  } else {
    t23 = $[27];
  }
  let t24;
  if ($[28] !== data.navLinks?.length || $[29] !== handleNav || $[30] !== isNavActive || $[31] !== isOverflowing) {
    t24 = !!data?.navLinks?.length && <Button className={cn("md:hidden text-white", {
      "md:inline-flex": isOverflowing
    })} variant="icon" onClick={() => handleNav(!isNavActive)} aria-label={"Ava k\xFClgmen\xFC\xFC"}><BurgerIcon /></Button>;
    $[28] = data.navLinks?.length;
    $[29] = handleNav;
    $[30] = isNavActive;
    $[31] = isOverflowing;
    $[32] = t24;
  } else {
    t24 = $[32];
  }
  let t25;
  if ($[33] !== t16 || $[34] !== t20 || $[35] !== t23 || $[36] !== t24) {
    t25 = <div className={t11}>{t16}{t20}{t23}{t24}</div>;
    $[33] = t16;
    $[34] = t20;
    $[35] = t23;
    $[36] = t24;
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  let t26;
  if ($[38] !== t10 || $[39] !== t25 || $[40] !== t8) {
    t26 = <div id={t8} className={t9}>{t10}{t25}</div>;
    $[38] = t10;
    $[39] = t25;
    $[40] = t8;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] !== t26 || $[43] !== t7) {
    t27 = <div className={t6}>{t7}{t26}</div>;
    $[42] = t26;
    $[43] = t7;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  let t28;
  if ($[45] !== T0 || $[46] !== onValueChange || $[47] !== t27 || $[48] !== value) {
    t28 = <T0 value={value} onValueChange={onValueChange} className={t5}>{t27}</T0>;
    $[45] = T0;
    $[46] = onValueChange;
    $[47] = t27;
    $[48] = value;
    $[49] = t28;
  } else {
    t28 = $[49];
  }
  let t29;
  if ($[50] !== data.navLinks?.length || $[51] !== handleNav || $[52] !== isNavActive || $[53] !== structuredHeader || $[54] !== value) {
    t29 = !!data?.navLinks?.length && <MobileNav openKey={value} data={structuredHeader} setOpen={handleNav} open={isNavActive} />;
    $[50] = data.navLinks?.length;
    $[51] = handleNav;
    $[52] = isNavActive;
    $[53] = structuredHeader;
    $[54] = value;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== t28 || $[57] !== t29) {
    t30 = <>{t28}{t29}</>;
    $[56] = t28;
    $[57] = t29;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  return t30;
};
const NavLink = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <NavigationMenuLink asChild={true}><TdsNextLink light={true} {...props} /></NavigationMenuLink>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(subItemLink, index_1) {
  const href_0 = subItemLink?.href;
  if (!href_0) {
    return null;
  }
  return <li key={`${subItemLink.id}-${index_1}`}><NavLink noUnderline={subItemLink.type !== "custom"} external={subItemLink.newTab} href={href_0}>{subItemLink.name}</NavLink></li>;
}
function _temp2(item) {
  const media = isMedia(item.logo);
  const mainLink = parseLink(item.link);
  return <NavigationMenuItem value={item.key || undefined} key={item.id}><NavigationMenuTrigger disableActiveOnHover={true}>{item.label}</NavigationMenuTrigger><NavigationMenuContent className="!w-full max-h-[80vh] overflow-y-auto"><div style={{
        gridTemplateColumns: `repeat(4, minmax(min-content, 30rem))`
      }} className="max-w-content grid grid-rows-1 text-md p-8 gap-4 justify-self-center w-full">{item.linkGroup?.map((subItem, index) => {
          const showMenuDescriptionBlock = !!media?.url || !!item.descriptionPlainText && !!item.description || !!item.includeLink && !!mainLink?.href;
          return <div className="space-y-4" key={`group-${item.id}-${index}`}>{index === 0 && showMenuDescriptionBlock && <div className="flex flex-col">{media?.url && <Image src={media.url} alt={media.alt ?? ""} width={media.width || 60} height={media.height || 60} priority={true} loading="eager" />}{!!item.descriptionPlainText && !!item.description && <div className="my-2 mt-4 font-bold text-neutral-0 max-w-96"><RichText data={item.description} enableGutter={true} /></div>}{!!item.includeLink && !!mainLink?.href && <NavLink external={mainLink.newTab} className="py-1 w-max" href={mainLink.href}>{mainLink.name}</NavLink>}</div>}{subItem.map((item_0, subIndex) => {
              const link = item_0?.link;
              if (!link) {
                return null;
              }
              let links;
              if (link.links.length) {
                links = link.links.map((link_0, index_0) => {
                  const href = link_0?.href;
                  if (!href) {
                    return null;
                  }
                  return <li key={`${item_0.id}-${index_0}`}><NavLink noUnderline={link_0.type !== "custom"} href={href} scroll={link_0.scroll}>{link_0.name}</NavLink></li>;
                });
              } else {
                links = item_0.links?.map(_temp).filter(Boolean) || [];
              }
              if (!link.href && !links.length) {
                return null;
              }
              return <div key={`${item_0.id}-${subIndex}-${index}`}>{link.href ? <NavLink noUnderline={link.type !== "custom"} external={link.newTab} className="py-1 font-bold" href={link.href} scroll={link.scroll}>{link.name}</NavLink> : <span className="tds-link py-1 font-bold justify-start !no-underline cursor-default tds-link--inline !text-neutral-0">{link.name}</span>}<ul className="ml-4">{links}</ul></div>;
            })}</div>;
        })}</div></NavigationMenuContent></NavigationMenuItem>;
}